import {Component, Input} from '@angular/core';
import {AppState} from "../../store/store";
import {Store} from "@ngrx/store";
import {FormControl, FormGroup} from "@angular/forms";
import {MatFormFieldAppearance} from "@angular/material/form-field";
import {selectMetricComponentObjects, selectMetricSourceGroups} from '../../store/selectors';
import {selectDataSetMetricsGroupComponentObjects} from '../../store/dataSetMetricsGroups/dataSetMetricsGroups.selectors';
import {Observable} from 'rxjs';
import {DatasetMetricsGroupComponentObjects} from '../../classes/dataset-metrics-group-component-object';
import {MetricComponentObjects} from '../../classes/metric-component-object';

@Component({
  selector: 'app-metrics-selector',
  templateUrl: './metrics-selector.component.html',
  styleUrls: ['./metrics-selector.component.scss']
})
export class MetricsSelectorComponent {
  @Input() public form: FormGroup;
  @Input() public control: FormControl;
  @Input() public controlName: string = 'metrics'
  @Input() public appearance: MatFormFieldAppearance = 'outline';
  @Input() public max: number;
  @Input() public labelAnimation: boolean = false;

  public readonly categories$: Observable<DatasetMetricsGroupComponentObjects> = this._store.select(selectDataSetMetricsGroupComponentObjects);
  public readonly sources$: Observable<DatasetMetricsGroupComponentObjects> = this._store.select(selectMetricSourceGroups);
  public readonly metrics$: Observable<MetricComponentObjects> = this._store.select(selectMetricComponentObjects);

  constructor(
    private _store: Store<AppState>
  ) {}
}
